import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { getURLSegment, toggleDrawer } from '../../helpers/helpers.js';

// Components
import Drawer from '../Drawer/Drawer';
import UsersList from './UsersList';
import LoadMore from '../Common/LoadMore';

const Users = observer(class Users extends React.Component {
  constructor() {
    super();
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      showEnrollments: [],
      enrollmentSid: null,
      enrollmentName: null,
      userSid: null,
      configuration: null,
      configurationSid: null,
      fundingRuleSid: null
    };
  }

  componentDidMount() {
    if(getURLSegment(this, 2) === 'view') {
      toggleDrawer(null, this, 'UserDetails');
    }
  }

  applyFilters(e) {
    e.preventDefault();

    let filters = {};

    const fname = this.fname.value;
    const lname = this.lname.value;
    const email = this.email.value;

    if(fname) {
      filters.firstName = `*${fname}*`;
    }

    if(lname) {
      filters.lastName = `*${lname}*`;
    }

    if(email) {
      filters.email = email;
    }

    if(fname || lname || email) {
      this.props.store.EnrollmentStore.getUsers(filters);
    } else {
      this.resetFilters();
    }
  }

  resetFilters() {
    this.fname.value = '';
    this.lname.value = '';
    this.email.value = '';

    this.props.store.EnrollmentStore.getUsers();
  }

  render() {
    const { translation } = this.props;
    const { installUsers, usersNext } = this.props.store.EnrollmentStore;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>
          </div>
        </header>

        <form className="filter" onSubmit={(e) => {this.applyFilters(e)}}>
          <div className="wrap">
            <fieldset className="filter__filters">
              <ul className="fields fields--inline">
                <li><legend>{translation.filter_heading}:</legend></li>
                <li>
                  <label className="meta" htmlFor="filter-fname">
                    {translation.fname}
                  </label>
                  <input
                    type="text"
                    id="filter-fname"
                    placeholder={translation.fname}
                    ref={(input) => {this.fname = input}}
                  />
                </li>
                <li>
                  <label className="meta" htmlFor="filter-lname">
                    {translation.lname}
                  </label>
                  <input
                    type="text"
                    id="filter-lname"
                    placeholder={translation.lname}
                    ref={(input) => {this.lname = input}}
                  />
                </li>
                <li>
                  <label className="meta" htmlFor="filter-email">
                    {translation.email}
                  </label>
                  <input
                    type="text"
                    id="filter-email"
                    placeholder={translation.email}
                    ref={(input) => {this.email = input}}
                  />
                </li>
              </ul>
            </fieldset>

            <div className="actions">
              <button
                className="btn"
                type="submit"
              >
                {translation.filter}
              </button>

              <button
                className="btn btn--outline"
                type="reset"
                onClick={this.resetFilters}
              >
                {translation.reset}
              </button>
            </div>
          </div>
        </form>

        <div className="wrap">
          <UsersList parent={this} {...this.props} />

          {usersNext &&
            <LoadMore
              url={usersNext}
              group={installUsers}
              text="Load more users"
              {...this.props}
            />
          }
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          userSid={this.state.userSid}
          enrollmentSid={this.state.enrollmentSid}
          enrollmentName={this.state.enrollmentName}
          configuration={this.state.configuration}
          configurationSid={this.state.configurationSid}
          fundingRuleSid={this.state.fundingRuleSid}
          preserveDrawer={true}
          approveForStudent={true}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('Users')(Users);



// WEBPACK FOOTER //
// ./src/app/components/Roster/Users.js